import TYPES from '../types';

export default () => {
  return {
    type: TYPES.CLEAR_INSTRUCTOR_SESSION,
  };
};
